<template>
  <div>
    <section-btn
      name="Create Project"
      :btn="1"
      :active="activeSection"
      v-on:buttonClicked="updateActiveSection"
    />
    <section-btn
      name="Create Project Admin"
      :btn="2"
      :active="activeSection"
      v-on:buttonClicked="updateActiveSection"
    />
    <section-btn
      name="Bulk Actions"
      :btn="3"
      :active="activeSection"
      v-on:buttonClicked="updateActiveSection"
    />
    <section-btn
      name="Projects and Schools"
      :btn="5"
      :active="activeSection"
      v-on:buttonClicked="updateActiveSection"
    />
    <section-btn
      name="B2C Coupons"
      :btn="6"
      :active="activeSection"
      v-on:buttonClicked="updateActiveSection"
    />
    <hr />
    <create-project v-if="activeSection === 1"> </create-project>
    <create-project-admin v-if="activeSection === 2"> </create-project-admin>
    <bulk-actions v-if="activeSection === 3"> </bulk-actions>
    <export-engagements v-if="activeSection === 4"> </export-engagements>
    <school-projects v-if="activeSection === 5"> </school-projects>
    <b2c-coupons v-if="activeSection === 6"></b2c-coupons>
  </div>
</template>

<script>
import CreateProjectAdminComponentVue from "./components/CreateProjectAdminComponent.vue";
import CreateProjectComponentVue from "./components/CreateProjectComponent.vue";
import BulkActionsComponent from "./components/BulkActionsComponent.vue";
import ExportEngagementsComponentVue from "./components/ExportEngagementsComponent.vue";
import SchoolsProjectComponentVue from "./components/SchoolsProjectComponent.vue";
import B2cCouponsComponentVue from "./components/B2cCouponsComponent.vue";
import SectionButtonComponent from "@/modules/global/components/SectionButtonComponent.vue";

export default {
  name: "admin-management",
  data() {
    return {
      activeSection: 1,
      activeLearner: null,
      viewAllParams: null
    };
  },
  components: {
    "create-project-admin": CreateProjectAdminComponentVue,
    "create-project": CreateProjectComponentVue,
    "bulk-actions": BulkActionsComponent,
    "export-engagements": ExportEngagementsComponentVue,
    "school-projects": SchoolsProjectComponentVue,
    "section-btn": SectionButtonComponent,
    "b2c-coupons" : B2cCouponsComponentVue
  },
  methods: {
    async updateActiveSection(payload) {
      this.activeSection = payload;
    }
  }
};
</script>
